import { useEffect, useState } from "react";
import { useCurrency } from "../context/CurrencyContext";

const TZ_MAP = [
  [/Asia\/(Kolkata|Calcutta)/, null],
  [/America\/(Toronto|Vancouver|Winnipeg|Halifax)/, "CAD"],
  [/America\//, "USD"],
  [/Europe\/London/, "GBP"],
  [/Europe\/(Zurich)/, "CHF"],
  [/Europe\//, "EUR"],
  [/Australia\//, "AUD"],
  [/Asia\/Dubai/, "AED"],
  [/Asia\/Qatar/, "QAR"],
  [/Asia\/Kuala_Lumpur/, "MYR"],
];

const REGION_NAMES = { USD: "the United States", CAD: "Canada", GBP: "the United Kingdom", EUR: "Europe", CHF: "Switzerland", AUD: "Australia", AED: "the UAE", QAR: "Qatar", MYR: "Malaysia" };

export default function CurrencySuggestion() {
  const { currency, setCurrency } = useCurrency();
  const [suggestion, setSuggestion] = useState(null);

  useEffect(() => {
    if (localStorage.getItem("b2l_currency") || localStorage.getItem("b2l_currency_dismissed")) return;
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
      for (const [re, code] of TZ_MAP) {
        if (re.test(tz)) {
          if (code) setSuggestion(code);
          return;
        }
      }
    } catch {}
  }, []);

  if (!suggestion || suggestion === currency) return null;

  const dismiss = () => {
    localStorage.setItem("b2l_currency_dismissed", "1");
    setSuggestion(null);
  };

  return (
    <div
      className="fixed bottom-20 xl:bottom-6 left-4 z-40 max-w-xs rounded-2xl border border-white/15 bg-navy-800 shadow-2xl p-5"
      data-testid="currency-suggestion"
    >
      <p className="text-xs text-slate-300 leading-relaxed">
        We noticed you may be visiting from {REGION_NAMES[suggestion]}. View prices in {suggestion}?
      </p>
      <div className="mt-4 flex gap-2">
        <button
          onClick={() => { setCurrency(suggestion); dismiss(); }}
          data-testid="currency-suggestion-accept"
          className="flex-1 rounded-full bg-flame hover:bg-flame-hover text-white text-xs font-bold py-2.5 transition-colors"
        >
          VIEW {suggestion}
        </button>
        <button
          onClick={dismiss}
          data-testid="currency-suggestion-dismiss"
          className="flex-1 rounded-full border border-white/20 text-slate-300 text-xs font-bold py-2.5 hover:border-flame/50 transition-colors"
        >
          KEEP INR
        </button>
      </div>
    </div>
  );
}
